module.exports = require('../internals/shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/internals/function-to-string.js
// module id = 336
// module chunks = 0